import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Table from '../../atoms/table/Table';
import NoDataTableRow from '../../molecules/table/NoDataTableRow';
import SkeletonTableRow from '../../molecules/table/SkeletonTableRow';
import UsersTableHeader from '../../molecules/table/UsersTableHeader';
import UsersTableRow from '../../molecules/table/UsersTableRow';
import useAuth from '../../hooks/useAuth';
const UsersTable = ({ users, loading }) => {
    const { can } = useAuth();
    const getDossierData = () => {
        if (loading) {
            return _jsx(SkeletonTableRow, {});
        }
        if (users.length === 0) {
            return _jsx(NoDataTableRow, {});
        }
        return users.map(user => (_jsx(UsersTableRow, { disabled: loading, href: can('user_update') ? `/gebruikers/${user.id}` : undefined, user: user }, user.id)));
    };
    return (_jsxs(Table, { children: [_jsx(UsersTableHeader, {}), getDossierData()] }));
};
export default UsersTable;
